import RestClient from './RestClient';
import { SignalContact } from '../models';

class SignalContacts extends RestClient {
    constructor() {
        super({
            model: SignalContact,
            entryPoint: 'signal-contacts',
            id_field: '_id',
            resource: 'signalContact',
            resources: 'signalContacts',
        });
    }

    listContacts() {
        return this.GET(`/${this.entryPoint}`)
            .then(response => response.json())
            .then(json => {
                if (Array.isArray(json.contacts))
                    return {
                        contacts: json.contacts.map((row: AnyObj) => new this.model(row)),
                    };
                throw new Error(json.err || json.error || '');
            });
    }

    patchContact(id: string, patch: { defaultProject?: string | null }) {
        return this.PATCH(`/${this.entryPoint}/${id}`, patch)
            .then(response => response.json())
            .then(json => {
                if (json.contact)
                    return { contact: new this.model(json.contact) };
                throw new Error(json.err || json.error || '');
            });
    }

    syncContacts() {
        return this.POST(`/${this.entryPoint}/sync`, {})
            .then(response => response.json())
            .then(json => {
                if (Array.isArray(json.contacts))
                    return {
                        contacts: json.contacts.map((row: AnyObj) => new this.model(row)),
                    };
                throw new Error(json.err || json.error || '');
            });
    }

    trustContact(id: string) {
        return this.POST(`/${this.entryPoint}/${encodeURIComponent(id)}/trust`, {})
            .then(response => response.json())
            .then(json => {
                if (json.contact)
                    return { contact: new this.model(json.contact) };
                throw new Error(json.err || json.error || '');
            });
    }
}

const SignalContactsApi = new SignalContacts();

export default SignalContactsApi;
